import { ConnectionBreakdownData } from '@components/TripBreakdown/ConnectionBreakdown'
import dateUtils from '@lib/date'

// validates if Open Return Fare Class is available in any connection
const anyConnectionHasOpenReturn = (connections?: Connection[] | null): boolean =>
  !!connections?.some(conn => conn.fares.some(fare => fare.fareClass?.journeyType === 'open_return'))

const prepareOpenReturnInbound = (outbound: ConnectionBreakdownData): ConnectionBreakdownData => {
  return {
    ...outbound,
    departureStation: outbound.arrivalStation,
    arrivalStation: outbound.departureStation,
    segments: outbound.segments.map(segment => ({
      ...segment,
      departureStation: segment.arrivalStation,
      arrivalStation: segment.departureStation,
    })),
  }
}

const getEndOfValidity = (departureTime: string, ticketValidityRule: TicketValidityRule) => {
  const { duration, durationType } = ticketValidityRule

  const departureDate = dateUtils.parse(departureTime, 'UTC')

  const endOfValidity = dateUtils.addDuration(departureDate, duration, durationType, true)

  return dateUtils.format(endOfValidity, 'EEE, dd MMM yyyy')
}

const checkFareClassIsOpenReturn = (fareClass: string, connection: Connection): boolean => {
  const foundFareClass = connection.fares.find(fare => fare.fareClass.code === fareClass)?.fareClass
  return foundFareClass
    ? isOpenReturnFareClass(foundFareClass)
    : /* istanbul ignore next -- the fallback will be covered with unit tests */ false
}

const isOpenReturnFareClass = (fareClass: FareClass | null): boolean =>
  Boolean(fareClass?.journeyType === 'open_return')

export default {
  anyConnectionHasOpenReturn,
  prepareOpenReturnInbound,
  getEndOfValidity,
  checkFareClassIsOpenReturn,
  isOpenReturnFareClass,
}
